package com.appsyde.shared.modules.team.domain.usecase

import com.appsyde.shared.modules.team.domain.repository.TeamRepository

class RevokeInviteUseCase(
    private val repository: TeamRepository
) {
    suspend operator fun invoke(inviteId: String): Boolean =
        repository.revokeInvite(inviteId)
}
